import { IColumn } from "@fluentui/react";

import { ActionColumnConfig, createActionsColumn } from "./actionsColumn";
import {
  createCommonColumns,
  createCompactCommonColumns
} from "./commonColumns";
import { createEnergyColumns } from "./energyColumns";
import { createTagColumns, createCompactTagColumns } from "./tagColumns";

import { ServicesCategoriesTypesEnum } from "@/modules/Settings/types/ServicesCategories.types";

interface BuildColumnsParams {
  isCompactMode: boolean;
  onColumnClick: (
    event: React.MouseEvent<HTMLElement>,
    column: IColumn
  ) => void;
  serviceCategoryType: ServicesCategoriesTypesEnum;
  actionConfig?: ActionColumnConfig;
  isSimExempt?: boolean;
}

const COLUMNS_BY_CATEGORY = {
  [ServicesCategoriesTypesEnum.TAG]: {
    normal: createTagColumns,
    compact: createCompactTagColumns
  },
  [ServicesCategoriesTypesEnum.ENERGY]: {
    normal: createEnergyColumns,
    compact: createEnergyColumns
  },
  default: {
    normal: createCommonColumns,
    compact: createCompactCommonColumns
  }
};

export function buildColumns({
  isCompactMode,
  onColumnClick,
  serviceCategoryType,
  actionConfig,
  isSimExempt
}: BuildColumnsParams): Array<IColumn> {
  const { normal, compact } =
    COLUMNS_BY_CATEGORY[serviceCategoryType] ?? COLUMNS_BY_CATEGORY.default;

  const createColumns = isCompactMode ? compact : normal;
  const columns = createColumns(onColumnClick, isSimExempt);

  const actionsColumn = createActionsColumn(actionConfig);

  return [...columns, actionsColumn];
}
